import { render, staticRenderFns } from "./NotesEdit.vue?vue&type=template&id=af69714a&"
import script from "./NotesEdit.vue?vue&type=script&lang=js&"
export * from "./NotesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports